import { utils } from '@bayclubs/ui-core';

export enum CourtBookingSaveActionTypes {
    LoadCourts = '[CourtBookingSave] Load courts',
    SearchPlayers = '[CourtBookingSave] Search players',
    ClearSaveForm = '[CourtBookingSave] Clear save form',
    LoadAvailableTimeSlots = '[CourtBookingSave] Load available time slots',
    ClearPlayers = '[CourtBookingSave] Clear players',
    SaveCourtBooking = '[CourtBookingSave] Save court booking',
    SaveCourtBookingSuccess = '[CourtBookingSave] Save court booking success',
    CheckPlayersMatrix = '[CourtBookingSave] Check players matrix',
}

export class SearchPlayersAction {
    static type = CourtBookingSaveActionTypes.SearchPlayers;
    constructor(public search: string) { }
}

export class LoadCourtsAction {
    static type = CourtBookingSaveActionTypes.LoadCourts;
    constructor(public date: utils.BcDate) { }
}

export class ClearSaveFormAction {
    static type = CourtBookingSaveActionTypes.ClearSaveForm;
}

export class LoadAvailableTimeSlotsAction {
    static type = CourtBookingSaveActionTypes.LoadAvailableTimeSlots;
    constructor(public timeSlotId: string, public date: utils.BcDate, public timeFromInMinutes: number) { }
}

export class ClearPlayersAction {
    static type = CourtBookingSaveActionTypes.ClearPlayers;
}

export class SaveCourtBookingAction {
    static type = CourtBookingSaveActionTypes.SaveCourtBooking;
}

export class SaveCourtBookingSuccessAction {
    static type = CourtBookingSaveActionTypes.SaveCourtBookingSuccess;
}

export class CheckPlayersMatrixAction {
    static type = CourtBookingSaveActionTypes.CheckPlayersMatrix;
}
